import PropTypes from "prop-types";
import { Modal, ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { Icon } from "@vds/icons";
import { Input } from "@vds/inputs";
import { Body, Title } from "@vds/typography";


import { useDispatch, useSelector } from "react-redux";
import { Select } from "antd";
import { useState } from "react";
import { createRequest, updateUI } from "../../store/actions/devices";
import ToastNotification from "../../global/components/ToastNotification";
import { isValidMacAddress } from "../../global/utility/macAddress";
import ATSToolTip from "../../global/components/ATSToolTip";
import CircleIIcon from "../../assets/circle_i.svg";
import "../../styles/deviceStyle.css";
// import { updateUI } from "../../../store/actions/asset";


function CreateDevice(props) {
  const { opHeaderText, formData, open, onExit, notification } = props;
  const onExitClose = () => {
    dispatch(
      updateUI({
        formData: {
          errors: {
            deviceType: false,
            major: false,
            minor: false,
            serialNumber: false,
            macAddress: false,
          },
          isOpen: false,
          deviceType: "",
          major: "",
          minor: "",
          serialNumber: "",
          macAddress: "",
        },
      })
    );
  };

  const handleFieldChange = (field, value) => {
    let error = {};

    if (field in formData?.errors) {
      error[field] = false;
    }

    dispatch(
      updateUI({
        formData: {
          ...formData,

          errors: { ...formData.errors, ...error },
          [field]: value,
        },
      })
    );
  };
  const isBTM = formData?.deviceType?.toUpperCase().startsWith("BTM");
  const isReelable = formData?.deviceType?.toUpperCase().startsWith("REELABLE");
  const isMocoSmart = formData?.deviceType?.toUpperCase().startsWith("MOCO SMART - N2");
  const handleSubmit = () => {
    if (isBTM && formData?.errors?.deviceType === false && formData?.errors?.major === false && formData?.errors?.minor === false) {
      dispatch(createRequest());
    } else if (isReelable && formData?.errors?.deviceType === false && formData?.errors?.serialNumber === false) {
      dispatch(createRequest());
    } else if (isMocoSmart) {
      const macValid = isValidMacAddress(formData?.macAddress);
      dispatch(
        updateUI({
          formData: {
            ...formData,
            errors: { ...formData.errors, macAddress: !macValid },
          },
        })
      );
      if (macValid) {
        dispatch(createRequest());
      }
    }
  };

  const dispatch = useDispatch();
  return (
    <Modal
      opened={open}
      disableOutsideClick={true}
      ariaLabel={`title Modal`}
      surface="light"
      fullScreenDialog={false}
      hideCloseButton={true}
      disableAnimation={false}
      onClose={onExitClose}
      width={"736px"}
      closeButton={
        <>
          <button
            style={{
              cursor: "pointer",
              position: "absolute",
              right: "15px",
              top: "15px",
              backgroundColor: "transparent",
              border: "none",
            }}
            onClick={onExitClose}
          >
            <Icon name="close" />
          </button>
        </>
      }

      {...props}
    >
      {notification.isActive &&
         (
          <ToastNotification
            type={notification.type}
            message={notification.message}
            description={notification.description}
            duration={1}
            style={notification.style}
          />
        )}
      <>
        <ModalTitle>
          <div className="mt-2">
            <Title size="large" bold={true}>Add device</Title>
          </div>
        </ModalTitle>

        <ModalBody>
          <div
            className={`d-flex flex-column justify-content-start align-items-start ${formData?.deviceType !== "" ? "mb-4" : ""
              }`}
          >
            <Body size="small">Device Model</Body>
            <Select
              className={
                formData?.errors?.deviceType
                  ? "shipment-form-fields shipment-form-field-error"
                  : "shipment-form-fields"
              }
              style={{ marginTop: "8px" }}
              placeholder="Select device type"
              value={formData?.deviceType}
              options={[
                { value: "", label: "Select device type" },
                ...(formData?.deviceTypes || []).map((type) => ({
                  label: type.devicetype,
                  value: type.devicetype,
                })),
              ]}
              onChange={(value) => {
                handleFieldChange("deviceType", value);
              }}
            />
          </div>


          {/* Conditionally render based on BTM vs Releable */}
          {isBTM && (
            <div className="d-flex flex-row justify-content-center align-items-center gap-4">
              <Input
                type="text"
                label="Major"
                name="major"
                required={true}
                error={formData?.errors?.major}
                value={formData.major}
                onChange={(e) => handleFieldChange("major", e.target.value)}
              />
              <Input
                type="text"
                label="Minor"
                name="minor"
                required={true}
                error={formData?.errors?.minor}
                value={formData.minor}
                onChange={(e) => handleFieldChange("minor", e.target.value)}

              />
            </div>
          )}
          {isReelable && (
            <div className="d-flex flex-column justify-content-center align-items-center gap-4">
              <Input
                type="text"
                label="Serial Number"
                name="serialNumber"
                value={formData.serialNumber}
                onChange={(e) => handleFieldChange("serialNumber", e.target.value)}
                required
              />
            </div>
          )}
          {isMocoSmart && (
            <div className="d-flex flex-column justify-content-center align-items-start gap-2">
              <div className="d-flex flex-row align-items-center">
                <Body size="small">MAC Address</Body>
                <ATSToolTip text="MAC address should be the same as shown on the device label">
                  <img
                    src={CircleIIcon}
                    className="mx-1"
                    alt="info"
                    style={{ verticalAlign: "middle" }}
                  />
                </ATSToolTip>
              </div>
              <Input
                id="moco-smart-mac-address"
                type="text"
                name="macAddress"
                label="MAC Address"
                required={true}
                error={formData?.errors?.macAddress}
                errorText="Enter a valid MAC address."
                value={formData.macAddress}
                onChange={(e) => handleFieldChange("macAddress", e.target.value)}
              />
            </div>
          )}
        </ModalBody>

        <ModalFooter
          buttonData={{
            close: {
              disabled: formData?.deviceType === "",
              width: "100%",
              children: "ADD",
              onClick: handleSubmit,
              className: formData?.deviceType === "" ? "custom-disabled-button" : "",
            },
            primary: {
              children: "Cancel",
              width: "100%",
              onClick: onExitClose,
            },
          }}
        />
      </>
    </Modal>
  );
}

CreateDevice.propTypes = {
  opHeaderText: PropTypes.string.isRequired,
  formData: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onExit: PropTypes.func.isRequired,
};

export default CreateDevice;

